import { RESTAURANT_SLUG } from '@/utils/environmentConfig'

/** Mandanten, bei denen Gäste keine Spiele sehen. */
const GAMES_DISABLED_SLUGS = ['ensu']

export function areCustomerGamesEnabled() {
  const slug = String(RESTAURANT_SLUG || '').toLowerCase()
  return !GAMES_DISABLED_SLUGS.includes(slug)
}
